/* eslint-disable indent */
import styled from 'styled-components';

import DestinationSearchInput from './DestinationSearchInput';

const StyledDestinationSearchInput = styled(DestinationSearchInput)`
    position: relative;

    .icon-container {
        position: absolute;
        z-index: 100;
        font-size: 2rem;
        font-variant: normal;
        line-height: 1;
        speak: none;
        text-transform: none;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        top: 50%;
        transform: translateY(-50%);
        left: 1.8rem;
    }

    .react-autosuggest__container {
        position: relative;
    }

    .react-autosuggest__input {
        width: 100%;
        height: 56px;
        padding: 18px 15px 18px 50px;
        font-family: 'Quicksand', sans-serif;
        font-weight: 500;
        font-size: 18px;
        border-width: 0;
        color: ${(props) => props.theme.colours.grey};
        border-radius: ${(props) => props.theme.corners.full}px;
        box-sizing: border-box;
        background-color: ${(props) =>
            props.backgroundColor ?? props.theme.colours.white};

        ::placeholder {
            /* Chrome, Firefox, Opera, Safari 10.1+ */
            color: ${(props) => props.theme.colours.grey};
            opacity: 1; /* Firefox */
        }

        :-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            color: ${(props) => props.theme.colours.grey};
        }

        ::-ms-input-placeholder {
            /* Microsoft Edge */
            color: ${(props) => props.theme.colours.grey};
        }
    }

    .react-autosuggest__input--focused {
        outline: none;
    }

    .react-autosuggest__input--open {
    }

    .react-autosuggest__suggestions-container {
        display: none;
    }

    .react-autosuggest__suggestions-container--open {
        display: block;
        position: absolute;
        top: 67px;
        width: 100%;
        border: 1px solid ${(props) => props.theme.colours.grey};
        background-color: ${(props) => props.theme.colours.white};
        font-family: 'Quicksand', sans-serif;
        font-weight: 500;
        font-size: 14px;
        border-radius: ${(props) => props.theme.corners.box.inside}px;
        z-index: 9999;
        min-height: 220px;
    }

    .bold {
        font-weight: 700;
        color: #53575d;
    }

    .react-autosuggest__suggestions-list {
        margin: 0;
        padding: 0;
        list-style-type: none;
    }

    .react-autosuggest__suggestion {
        cursor: pointer;
        padding: 10px 20px;
    }

    .react-autosuggest__suggestion--highlighted {
        background-color: #ddd;
    }

    .react-autosuggest__section-container {
        border-top: 1px dashed #ccc;
    }

    .react-autosuggest__section-container--first {
        border-top: 0;
    }

    .react-autosuggest__section-title {
        padding: 10px 0 0 20px;
        font-size: 16px;
        font-weight: 700;
        color: ${(props) => props.theme.colours.primary};
    }
`;
export default StyledDestinationSearchInput;
